import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { PostData } from '../../../services/PostData';
import { GetData } from '../../../services/GetData';
import { Container, Row, Col, CardGroup, Card, CardBody, Button, Input, InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap';
import $ from 'jquery';
const GLOBAL = require('../../../Globals');

class Login extends Component {

	constructor(props) {
		super(props);
		this.state = {
			_username: null,
			_password: null,
			_redirect: false,
			_message: '',
			alertClass: '',
			posts: [],
			role: '',
			userid: ''
		}
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
	}

	/** set value **/
	onChange(e) {
		this.setState({ [e.target.name]: e.target.value });
	}

	/** submit form **/
	onSubmit(e) {
		e.preventDefault();
		$("#showLoader").show();
		if (this.state._username && this.state._password) {

			PostData('login/checklogin', this.state).then((result) => {
				$("#showLoader").hide();
				let res = result;
				if (res.status == '1') {
					sessionStorage.setItem('userData', JSON.stringify(res));
					sessionStorage.setItem('userrole', res.userrole);
					this.setState({ userid: res.userid, role: res.userrole });
					sessionStorage.setItem('isLogged','yes');
					this.setState({ _redirect: true });
				}
				else {

					this.setState({
						_message: 'Invalid Username (or) Password',
						alertClass: 'alert alert-danger'
					});
				}
			});
		}
	}

	/** this function will be call when page loading **/
	componentDidMount() {

		this.getacyear();
	}

	getacyear() {

		GetData('login/checkacyear').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					posts: responseJson
				});
			}
		});
	}

	render() {

		if (this.state.role == 'accountant' && this.state._redirect && sessionStorage.getItem('userData')) {

			// return (<Redirect to = {GLOBAL.BASE_URL+'accounts/login/store_session/'+this.state.userid} />);
			location.href = GLOBAL.ACC_URL + 'accounts/login/store_session/' + this.state.userid;
		}
		else if ((this.state.role == 'admin' || this.state.role == 'staff') && this.state._redirect && sessionStorage.getItem('userData')) {

			return (<Redirect to='/dashboard' />);
		}
		else if((this.state.role == 'markentry' || this.state.role == 'classteacher') && this.state._redirect && sessionStorage.getItem('userData')){
			return (<Redirect to='/academic/page'/>);
		}
		else if(this.state.role == 'questionbank' && this.state._redirect && sessionStorage.getItem('userData')){
			return (<Redirect to='/question/page'/>);
		}

		return (
			<div className="app flex-row align-items-center">
				<Container>
					<Row className="justify-content-center">
						<Col md="8">
							<CardGroup>
								<Card className="p-4">
									<div className={this.state.alertClass}>
										{this.state._message}
									</div>
									<CardBody>
										<h1>Login</h1>
										<p className="text-muted">Sign In to your account</p>
										<form action="" method="post" encType="multipart/form-data" onSubmit={this.onSubmit} >
											<InputGroup className="mb-3">
												<InputGroupAddon addonType="prepend">
													<InputGroupText>
														<i className="icon-user"></i>
													</InputGroupText>
												</InputGroupAddon>
												<Input type="text" name="_username" placeholder="Username" onChange={this.onChange} />
											</InputGroup>
											<InputGroup className="mb-4">
												<InputGroupAddon addonType="prepend">
													<InputGroupText>
														<i className="icon-lock"></i>
													</InputGroupText>
												</InputGroupAddon>
												<Input type="password" name="_password" placeholder="Password" onChange={this.onChange} />
											</InputGroup>
											<Row>
												<Col xs="6">
													<Button color="primary" className="px-4">Login</Button>
												</Col>
											</Row>
										</form>
									</CardBody>
								</Card>
								<Card className="text-white bg-primary py-5 d-md-down-none" style={{ width: '44%' }}>
									<CardBody className="text-center">
										<div style={{ marginTop: '26px' }}>
											<img src={GLOBAL.BASE_URL + 'public/sclogo/logo.jpg'} style={{ width: '25%' }} alt='' />
											<h3>{GLOBAL.Sclful_NAME}</h3>
										</div>
									</CardBody>
								</Card>
							</CardGroup>
						</Col>
					</Row>
				</Container>
			</div>
		);
	}
}

export default Login;



// WEBPACK FOOTER //
// ./src/views/Pages/Login/Login.js